import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  groupBy,
  map,
  mapValues,
  pipe,
  toPairs,
} from 'lodash/fp';
import { apiUrl } from 'services/fetch';
import table from 'components/table';
import utils from 'utils';

const Table = table();

const { checkStatus, parseJSON } = utils.http;
const { number } = utils.sort;

class CountyTableView extends Component {
  constructor() {
    super();

    this.state = {
      columns: [],
      rowData: [],
    };

    this.requestData = this.requestData.bind(this);
  }

  componentDidMount() {
    this.requestData();
  }

  requestData() {
    const {
      match: {
        params: {
          indicatorName: slug,
          state,
        },
      },
    } = this.props;

    fetch(`${apiUrl()}/api/usdata/indicators/${slug}/counties/${state}`)
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data, timeframes }) => {
        const orderedTimeframes = timeframes
          .sort(({ value: a }, { value: b }) => number()(a, b))
          .map(({ label }) => label)
          .reverse();

        const headers = ['County', ...orderedTimeframes].map((x, idx) => ({
          title: x,
          id: x.toLowerCase(),
          ordinal: idx,
        }));

        const groupedData = pipe([
          groupBy('geography._id'),
          mapValues((item) => item.map((cell) => ({
            ...cell,
            ordinal: headers
              .find(({ id }) => id === cell.timeframe.label).ordinal,
          })).sort(({ ordinal: a }, { ordinal: b }) => a - b)),
        ])(data);

        const geographies = data
          .reduce((acc, { geography: { _id, geography } }) => (
            !Object.hasOwnProperty.call(acc, _id) ?
              ({ ...acc, [_id]: geography }) :
              acc
          ), {});

        const rowData = pipe([
          toPairs,
          map(([key, val]) => ({
            rowId: key,
            pin: state === geographies[key],
            data: [
              {
                idx: 0,
                fixed: 'left',
                align: 'left',
                formattedValue: geographies[key],
              },
              ...val.map(({ ordinal, formattedValue }) => ({
                idx: ordinal,
                align: 'right',
                formattedValue,
              })),
            ],
          })),
        ])(groupedData);

        const columns = headers.map(({ title, id, ordinal }) => ({
          label: title,
          id,
          idx: ordinal,
          colId: id,
          fixed: (0 === ordinal) ? 'left' : undefined,
        }));

        return { columns, rowData };
      })
      .then(({ columns, rowData }) => this.setState({ columns, rowData }));
  }

  render() {
    const { columns, rowData } = this.state;

    return (
      <div>
        {0 === columns.length ?
          (<div>Loading Data...</div>) :
          (<Table columns={columns} rowData={rowData} />)}
      </div>
    );
  }
}

CountyTableView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      indicatorName: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default CountyTableView;



// WEBPACK FOOTER //
// ./app/components/countyTableView/index.js